import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as dayjs from 'dayjs';
import { ProfileService } from 'src/app/provider/profile.service';
import { RequestsService } from 'src/app/provider/requests.service';
import { ProfileModel } from 'src/app/views/models/profile.model';

@Component({
  selector: 'kt-reservation-detail',
  templateUrl: './reservation-detail.component.html',
  styleUrls: ['./reservation-detail.component.scss']
})
export class ReservationDetailComponent implements OnInit {

  reservation: any = null;
  badgeColor: string = null;
  night: number = null;
  totalPrice: number = null;

  today: Date = new Date();

  profileDisplay = false;
  ChatIsVisible = false;

  userProfile: ProfileModel = null;
  paymentMethods = JSON.parse(localStorage.getItem('savedPayments')) || [];

  savedReceipts = JSON.parse(localStorage.getItem('savedReceipts')) || [];
  receiptType = 'company';
  receiptData = this.savedReceipts[0] || {
    id: null,
    created_date: dayjs(this.today).format('DD-MM-YYYY'),
    paymentMethod: this.paymentMethods[0] || null,
    amount: this.totalPrice,
    companyName: null,
    idNo: null,
    firstName: null,
    lastName: null,
    taxOffice: null,
    taxId: null,
    country: null,
    province: null,
    zip: null,
    city: null,
    address: null,
    addressCondt: null,
    phone: null,
    fax: null,
    email: null
  };

  constructor(
    private actvrt: ActivatedRoute,
    private requestService: RequestsService,
    private mldctrl: NgbModal,
    private profile: ProfileService
  ) { }

  ngOnInit() {
    this.totalPrice = 0;
    const id = this.actvrt.snapshot.params['reservationid'];
    this.reservation = this.requestService.room_reservation_change$.getValue().find(x => x.id == id);
    console.log(this.reservation);

    if (this.reservation.approval_status === 'Pending') {
      this.badgeColor = 'badge-warning';
    } else  if (this.reservation.approval_status === 'Rejected') {
      this.badgeColor = 'badge-danger';
    } else {
      this.badgeColor = 'badge-success';
    }

    if (this.reservation !== undefined || null) {
      this.night = dayjs(this.reservation.end_date).diff(this.reservation.start_date, 'days') + 1;
      this.reservation.requestlines.forEach(item => {
        this.totalPrice += (item.unit_price * item.quantity * this.night);
      });
      this.profile.getProfilebyID(this.reservation.profile_id).subscribe((resp: ProfileModel) => {
        this.userProfile = resp;
        console.log(this.userProfile);

      });
    }

  }

  open(modal: any) {
    this.mldctrl.open(modal, { windowClass: 'tax-modal' });
  }

  chat() {
    this.ChatIsVisible = !this.ChatIsVisible;
  }

  print(div: HTMLElement) {
    div.classList.add('show');
    window.print();
    div.classList.remove('show');
  }

  saveReceipt(div: HTMLElement) {
    this.receiptData.id = this.reservation.id;
    this.receiptData.amount = this.totalPrice;
    this.savedReceipts.push(this.receiptData);
    localStorage.setItem('savedReceipts', JSON.stringify(this.savedReceipts));
    this.print(div);
  }
}
